import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  login: false,
}

// sliceを生成
export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    login: (state, action) => {
      return {
        ...state,
        login: true,
      }
    },
    logout: (state, action) => {
      return {
        ...state,
        login: false,
      }
    },
  }
})

export const { login, logout } = loginSlice.actions

export default loginSlice.reducer
